import { Component, Input } from '@angular/core';
import {
  BookingOfferTaxesDetailInterface,
  BookingTaxEstimateInterface,
} from '@sport-activities/sdk';

import { CheckoutItem } from '~/checkout/model/checkout-item.model';

@Component({
  selector: 'app-tax-excluded',
  templateUrl: './tax-excluded.component.html',
})
export class TaxExcludedComponent {
  @Input() public item: CheckoutItem;
  @Input() public showExternalPayment: boolean;
  @Input() public taxes: BookingTaxEstimateInterface;
  @Input() public taxesDetail: BookingOfferTaxesDetailInterface[];
}
